import { TUser } from '@typings'

/** Logic for obtaining username from User entity data. */
export default function extractUserName(user: TUser): string {
	return `${user.firstName} ${user.lastName}`
}
